export default __webpack_public_path__ + "static/media/geyserInnerTank.b01077fb.jpg";